import React from "react";
import { publicRoutes, adminRoutes } from "./router.link";
import { Outlet, Route, Routes } from "react-router-dom";
import Header from "../common/header";
import Footer from "../common/footer";
import Progress from "../common/progressbar";
import ScrollToTop from "../common/ScrollToTop";
import { useKeycloak, ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from "../../keycloak";

const initOptions = {
    onLoad: 'check-sso' as const,
    silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
    checkLoginIframe: false, // Disable iframe check for cross-domain compatibility
    pkceMethod: 'S256' as const, // Use PKCE for better security
    enableLogging: true, // Enable debug logging
    messageReceiveTimeout: 10000,
    responseMode: 'fragment' as const,
};

const AllRoutes = () => {
  // const { keycloak } = useKeycloak(); // Removed top-level useKeycloak

  const KeycloakWrapper = ({ children }: { children: React.ReactNode }) => {
     return (
        <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
            {children}
        </ReactKeycloakProvider>
     );
  };

  const HeaderLayout = () => (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Progress/>
      <Footer />
    </>
  );

  const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
    const { keycloak, initialized } = useKeycloak();

    if (!initialized) {
        return <div>Loading...</div>;
    }

    if (!keycloak.authenticated) {
        keycloak.login();
        return <div>Redirecting to login...</div>;
    }

    return children;
  };

  return (
    <>
      <Routes>
        {/* Public Routes - No Keycloak */}
        <Route element={<HeaderLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        {/* Admin Routes - With Keycloak */}
        <Route element={
            <KeycloakWrapper>
                <HeaderLayout />
            </KeycloakWrapper>
        }>
          {adminRoutes.map((route, idx) => (
            <Route path={route.path} element={<PrivateRoute>{route.element}</PrivateRoute>} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default AllRoutes;
